import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapMutations, mapState, mapActions } from 'vuex';
import { isGamePlay } from '../utils';
import { previewMixin } from '../mixin/preview.js';

export default {
  mixins: [previewMixin],

  props: {
    config: {
      type: Object,
      required: true
    },

    resettable: {
      type: Boolean,
      required: true
    },

    isDefault: {
      type: Boolean,
      default: false
    }
  },

  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    },
    gameDifficultyList: function gameDifficultyList(state) {
      return _.get(state, 'creative.template.gameConfigResource.gameDifficultyList') || [];
    },
    groupsConfig: function groupsConfig(state) {
      return state.creative.template.groupsConfig || [];
    }
  })),

  methods: _extends({}, mapMutations({
    updateActiveCategoryId: 'creative/template/updateActiveCategoryId',
    updateActiveCategoryNode: 'creative/template/updateActiveCategoryNode',
    changeDefaultGameDifficulty: 'creative/template/changeDefaultGameDifficulty',
    updatePreviewGroupConfig: 'creative/template/updatePreviewGroupConfig'
  }), mapActions({
    removeGameDifficulty: 'creative/template/removeGameDifficulty'
  }), {
    delete: function _delete() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.removeGameDifficulty({ tag: _this.config.tag });

                _this.templateConfig.category.forEach(function (item) {
                  if (isGamePlay(item.id)) {
                    var targetCategory = item.sub_category.find(function (item) {
                      return item.tag !== _this.config.tag && _this.gameDifficultyList.find(function (j) {
                        return j.tag === item.tag;
                      });
                    });
                    _this.updateActiveCategoryId(targetCategory.id);
                    _this.updateActiveCategoryNode(targetCategory);
                    _this.changeDefaultGameDifficulty({ tag: targetCategory.tag });
                  }
                });

                // 删除当前坑位资源时跳转至第一个组合

                if (!_this.isDefault) {
                  _context.next = 6;
                  break;
                }

                _this.updatePreviewGroupConfig(_this.groupsConfig[0].name);
                _context.next = 6;
                return _this.preview();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleOnConfirm: function handleOnConfirm() {
      this.delete();
    },
    handleOnCancel: function handleOnCancel() {}
  })
};